import { withInstall } from '@bigin/utils'
import Dialog from './src/dialog.vue'

export const BDialog = withInstall(Dialog)
export default BDialog

export * from './src/use-dialog'
export * from './src/dialog'
